/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Projection configuration for the consumer.
 * @export
 * @interface ConsumerProjection
 */
export interface ConsumerProjection {
    /**
     * List of fields to include in the projection.
     * @type {Array<string>}
     * @memberof ConsumerProjection
     */
    include?: Array<string>;
    /**
     * List of fields to exclude from the projection.
     * @type {Array<string>}
     * @memberof ConsumerProjection
     */
    exclude?: Array<string>;
}

/**
 * Check if a given object implements the ConsumerProjection interface.
 */
export function instanceOfConsumerProjection(value: object): value is ConsumerProjection {
    return true;
}

export function ConsumerProjectionFromJSON(json: any): ConsumerProjection {
    return ConsumerProjectionFromJSONTyped(json, false);
}

export function ConsumerProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'include': json['include'] == null ? undefined : json['include'],
        'exclude': json['exclude'] == null ? undefined : json['exclude'],
    };
}

export function ConsumerProjectionToJSON(json: any): ConsumerProjection {
    return ConsumerProjectionToJSONTyped(json, false);
}

export function ConsumerProjectionToJSONTyped(value?: ConsumerProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'include': value['include'],
        'exclude': value['exclude'],
    };
}

